module.exports = __webpack_public_path__ + "img/profile2.05378078.svg";